import React from 'react';
import { observer } from 'mobx-react';
import * as IoC from 'typescript-ioc';
import Text from '../../../global/text/text';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { DateFnsFormats } from '../../../../infrastructure/date-formatter';
import { IOrderTemplateDTO } from '../../../../api/blueprints/order.template.types';

type Props = {
    item: IOrderTemplateDTO;
};

export const OrderTemplatesListItem = observer((props: Props): JSX.Element => {
    const { item } = props;

    const dateTimeFormatter = IoC.Container.get<DateTimeFormatter>(DateTimeFormatter);
    const createdAt = dateTimeFormatter.dateToFormattedString(new Date(item.createdAt), DateFnsFormats.StringifiedMonthDayYear);
    const updatedAt = item.updatedAt && dateTimeFormatter.dateToFormattedString(new Date(item.updatedAt), DateFnsFormats.StringifiedMonthDayYear);

    return (
        <tr>
            <Text tag='td' message={item.name} withEllipsis />
            <Text tag='td' className='created-at--column' message={createdAt} />
            <Text tag='td' className='updated-at--column' message={updatedAt} />
            <Text tag='td' message={item.description} withEllipsis />
        </tr>
    );
});
